import React, { Component } from 'react';
import './Windows.css';
import QuoteForm from '../QuoteForm/QuoteForm';
import StyleCard from '../StyleCards/StyleCard';
import doubleHung from '../../Assets/windowStyles/DoubleHung.jpg';
import awning from '../../Assets/windowStyles/Awning.jpg';
import casement from '../../Assets/windowStyles/Casement.jpg';
import garden from '../../Assets/windowStyles/Garden.jpg';
import picture from '../../Assets/windowStyles/Picture.jpg';
import shape from '../../Assets/windowStyles/Shape.jpg';
import slider from '../../Assets/windowStyles/Slider.jpg';
import bay from '../../Assets/windowStyles/Bay.jpg';
import { BrowserRouter as Router, Routes,Route } from 'react-router-dom';


class Windows extends Component {
  render() {
  return (
    <div class='windowMain'>
      <div class='windowHeader'>
        <h1 class="windowTitle">
          Windows
        </h1>
      </div>
      <div class="visionSect">
         <h2>Window Replacements</h2>
         <div class="vision">
          Our Vision at DNS Home Exteriors has always been to set a new standard of excellence for contractors that raises the bar when it comes to first-class customer service, industry knowledge, and craftsmanship.
         </div>
      </div>
      <hr></hr>
      <div class="windowInfoSect">
        <section class="windowInfo">
          <div>
          <h4>It's time to replace your window</h4>
          <p>Replacing the windows of your home is a worthwhile investment and
          your home certainly deserves the best. To protect your investment,
          you need both high-quality windows and professional installation for
          your window replacement project. We are always ready to provide our
          clients with the best service and installation for replacement windows
          in Denver and the surrounding areas.
          <br></br>
          <br></br>
          Old windows ruin the overall value and charm of your home and increase
          your monthly electric bill! You don’t have to settle for outdated and
          inefficient windows. It’s time to retire those dated windows and update
           your home with some beautiful new energy-efficient windows from DNS Home Exteriors.</p>
          </div>
        </section>
        <section class="quotoForm">
          <QuoteForm />
        </section>
      </div>
    <div class="sectionSpacer">
       <h2>Available Replacement Window Options</h2>
    </div>
    <div class="replacementOptions">
      <StyleCard
        image={doubleHung}
        title="Double-Hung"
        description=""
        />
        <StyleCard
          image={casement}
          title="Casement"
          description=""
          />
        <StyleCard
          image={picture}
          title="Picture"
          description=""
        />
        <StyleCard
          image={slider}
          title="Slider"
          description=""
          />
        <StyleCard
          image={garden}
          title="Garden"
          description=""
          />
        <StyleCard
          image={shape}
          title="Geometric"
          description=""
          />
        <StyleCard
          image={bay}
          title="Bay"
          description=""
          />
        <StyleCard
          image={awning}
          title="Awning"
          description=""
          />
    </div >

  </div>
  )
};
}

export default Windows;
